export default function ErrorComponent({ error }: { error?: string }) {
	console.error(error);
	return <></>;
}
